import { render, staticRenderFns } from "./SupplierStat.vue?vue&type=template&id=1fc507fe&scoped=true&"
import script from "./SupplierStat.vue?vue&type=script&lang=js&"
export * from "./SupplierStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc507fe",
  null
  
)

export default component.exports